import { TablePagination } from '@mui/material';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';

const CustomTable = ({
  tableData = [],
  filteredCustomers = [],
  rowsPerPage,
  setRowsPerPage,
  sortField,
  sortOrder,
  handleSortChange,
  currentPage,
  setCurrentPage,
  setFilterApiCall,
  loading,
  bodyTemplates = [],
  totalRecords = 0,
  checkbox = true,
  pagination = true,
  pageName = '',
}) => {
  const [hoveredRowIndex, setHoveredRowIndex] = useState(null);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
    setFilterApiCall(true);
  };

  const handleChangeRowsPerPage = (event, newPage) => {
    setCurrentPage(0);
    setFilterApiCall(true);
    setRowsPerPage(parseInt(event.target.value));
  };

  return (
    <>
      {/* ==== For table loading ==== */}
      {loading && (
        <DataTable
          value={loading ? [] : []}
          removableSort
          reorderableRows={false}
          tableStyle={{
            minHeight: pageName === 'Dashboard' ? '330px' : '400px',
          }}
          emptyMessage={
            loading && (
              <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                <Spinner animation="border" />
              </div>
            )
          }
        >
          {tableData &&
            tableData.map((col, index) => <Column key={index} header={col?.header} sortable style={col?.style} />)}
        </DataTable>
      )}
      {/* ==== For table no data table ==== */}
      {loading !== true && (filteredCustomers.length === 0 || filteredCustomers.length === undefined) && (
        <DataTable
          value={filteredCustomers}
          removableSort
          reorderableRows={false}
          tableStyle={{
            minHeight: pageName === 'Dashsboard' ? '330px' : '400px',
          }}
          emptyMessage={<div className="text-center fs-6">No Data Found</div>}
        >
          {tableData &&
            tableData.map((col, index) => <Column key={index} header={col?.header} sortable style={col?.style} />)}
        </DataTable>
      )}
      {/* ==== For table ==== */}
      {filteredCustomers.length !== 0 && filteredCustomers.length !== undefined && loading !== true && (
        <span>
          <DataTable
            value={filteredCustomers}
            rows={rowsPerPage}
            reorderableRows={false}
            first={currentPage * rowsPerPage}
            tableStyle={{ minWidth: '50rem' }}
            sortField={sortField}
            sortOrder={sortOrder === 0 ? 1 : sortOrder}
            onSort={handleSortChange}
            scrollable
            onRowMouseEnter={(e) => setHoveredRowIndex(e.index)}
            onRowMouseLeave={() => setHoveredRowIndex(null)}
          >
            {/* ==== For checkbox ==== */}
            {checkbox && <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />}
            {tableData &&
              tableData.map((col, index) => (
                <Column
                  alignFrozen={col?.alignFrozen}
                  frozen={col?.frozen === true}
                  key={index}
                  field={col?.field}
                  header={col?.header}
                  headerClassName={col?.frozen ? 'custom-header-bg' : ''}
                  sortable={index == 0 ? false : col?.sortable}
                  style={col?.style}
                  body={(rowData, options) =>
                    bodyTemplates[col?.field]
                      ? bodyTemplates[col?.field](rowData, {
                          ...options,
                          isRowHovered: hoveredRowIndex === options.rowIndex,
                        })
                      : rowData[col?.field]
                  }
                />
              ))}
          </DataTable>
          {loading !== true && pagination && (
            <div className="mt-1">
              <TablePagination
                component="div"
                count={totalRecords}
                page={currentPage}
                rowsPerPageOptions={[5, 10, 20, 25]}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          )}
        </span>
      )}
    </>
  );
};

export default CustomTable;
